var app = angular.module("leonardo");

var ReportsTemplateListFilters = function(
  $scope,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  CategoryCacheRestService,
  SubcategoryCacheRestService,
  TemplateService
) {

  $controller('ReportsFilters', { $scope: $scope });
  $scope.categories = [];
  CategoryCacheRestService.getCategories().then(function(response) {
    if (response && response.length > 0) {
      $scope.categories = response.map(function(category) {
        return { id: category.id, name: category.name }; 
      });
    } else {
      console.warn('No categories found or invalid response');
      $scope.categories = []; 
    }
  }, function(error) {
    console.error('Failed to fetch categories:', error);
    $scope.categories = []; 
  });

  $scope.$watch('categories', function(newValue) {
    if (newValue.length > 0) {
      const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
      if (categoryFilter) {
        categoryFilter.options = newValue;
      }
    }
  });

 
 $scope.subCategories = [];

 SubcategoryCacheRestService.getSubCategories().then(function(response) {
   if (response && response.length > 0) {
     $scope.subCategories = response.map(function(category) {
       return { id: category.id, name: category.name }; 
     });
   } else {
     console.warn('No subcategories found or invalid response');
     $scope.subCategories = []; 
   }
 }, function(error) {
   console.error('Failed to fetch subcategories:', error);
   $scope.subCategories = []; 
 });
 $scope.$watch('subCategories', function(newValue) {
   if (newValue.length > 0) {
     const subCategoryFilter = $scope.filters_options.find(option => option.id === 'subcategory');
     if (subCategoryFilter) {
      subCategoryFilter.options = newValue;
     }
   }
 });

  if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty) {
    $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
  }

  $scope.filters_valid = ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()) ?
    ReportService.filtersTemplateAdmin : ReportService.filtersTemplate;

  $scope.actions = [
    {id: 'added', name:'Added'},
    {id: 'modified', name:'Modified'},
    {id: 'deleted', name:'Deleted'}
  ];

  $scope.templateStatus = [
    { id: TemplateService.STATUS_PUBLISHED, name: 'Published' },
    { id: TemplateService.STATUS_UNPUBLISHED, name: 'Unpublished' }
  ];

  $scope.filters_options = [];

  $scope.initOptions = function() {
    if ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()) {
      $scope.filters_base = $scope.removeFiltersOptions(
        [
          'account_reports',
          'managed_by_reports',
          'group_reports',
          'portfolio_reports',
          'property_reports',
          'group_by'
        ]
      );
    }
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'name',
        name: 'Template Name',
        label: 'Template Name',
        inline: false,
        type: 'text',
        placeholder: 'Template Name',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'status',
        name: 'Template Status',
        label: 'Template Status',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Status',
        condition: true,
        options: $scope.templateStatus,
        conflicts: []
      },
      {
        id: 'user_activity_action_done',
        name: 'Action Done',
        label: 'Action Done',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Actions',
        condition: true,
        options: $scope.actions,
        conflicts: []
      },
      {
        id: 'category',
        name: 'Category',
        label: 'Category',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Categories',
        options: $scope.categories, 
        condition: true,
        conflicts: ['sector']
      },
      {
        id: 'subcategory',
        name: 'Subcategory',
        label: 'Subcategory',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Subcategories',
        condition: true,
        options:$scope.subCategories,
        conflicts: ['sector']
      }
    ]);
  };

  $scope.initOptions();
  $scope.filterService.showFilters(['property_reports']);


  if ($scope.filters_name !== 'filters_report') {
    var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

    if (!angular.isArray(filters)) {
      filters = filters.split(',');
    }

    angular.forEach($scope.filterService.filters, function(value, key) {
      if (!_.contains(filters, key) && $scope.isValid(key)) {
        filters.push(key);
      }
    });
    if (!$scope.filterService.hasFilter('status')) {
      $scope.filterService.setFilter('status', TemplateService.STATUS_PUBLISHED, true);
      if (!_.contains(filters,'status')) {
        filters.push('status');
      }
    }

    if (!$scope.filterService.hasFilter('name') && !_.contains(filters,'name')) {
      filters.push('name');
    }

    $scope.filterService.setFilter($scope.filters_name, filters);

    $timeout(function() {
      if ((filters.indexOf('from_date') >= 0)  && isNull(ReportService.getQuickReport())) {
        $scope.filterService.removeFilter('from_date', true);
        filters.splice(filters.indexOf('from_date'), 1);
      }

      if ((filters.indexOf('to_date') >= 0)  && isNull(ReportService.getQuickReport())) {
        $scope.filterService.removeFilter('to_date', true);
        filters.splice(filters.indexOf('to_date'), 1);
      }

      if ((filters.indexOf('date_range') >= 0) && isNull(ReportService.getQuickReport())) {
        $scope.filterService.removeFilter('date_range', true);
        filters.splice(filters.indexOf('date_range'), 1);
      }

      $scope.filterService.setFilter($scope.filters_name, filters);
      $rootScope.$broadcast('filters-report:initialized');
    }, 0);
  }

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_TEMPLATE);
  }, 100);
};

app.controller('ReportsTemplateListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'CategoryCacheRestService', 
  'SubcategoryCacheRestService',
  'TemplateService',
  ReportsTemplateListFilters
]);
 